var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"width":"100%","height":"500","src":_vm.host + _vm.lista_evento.videos_id,"frameborder":"0","allowfullscreen":"","allow":"autoplay;muted;loop;","autoplay":"","loop":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }